import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="post-harvest--drying-allocation"
// Manages drying allocation table and group settings: serializes allocations,
// drying groups data, and triggers autosubmit.
export default class extends Controller {
  static targets = [
    "allocationList",
    "containersDataField",
    "groupCard",
    "dryingGroupsDataField",
  ];

  connect() {
    this.formElement = this.element.closest("form");
    this.beforeSubmitHandler = this.serialize.bind(this);
    if (this.formElement) {
      this.formElement.addEventListener("submit", this.beforeSubmitHandler);
    }
    this.serialize();
  }

  disconnect() {
    if (this.formElement) {
      this.formElement.removeEventListener("submit", this.beforeSubmitHandler);
    }
  }

  update() {
    this.serialize();
  }

  triggerAutosubmit() {
    this.serialize();
    if (this.formElement) {
      let hidden = this.formElement.querySelector("input[name='_autosubmit']");
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "_autosubmit";
        this.formElement.appendChild(hidden);
      }
      hidden.value = "1";
      this.formElement.requestSubmit();
    }
  }

  toggleRecipe(event) {
    const card = event.target.closest("[data-drying-group-card]");
    if (!card) return;

    const recipeField = card.querySelector("[data-recipe-field]");
    if (!recipeField) return;

    const method = event.target.value;
    recipeField.classList.toggle("hidden", method !== "dryer");
    this.serialize();
  }

  serialize() {
    // Serialize allocation rows
    const allocationRows = this.allocationListTarget.querySelectorAll(
      "[data-container-row]",
    );
    const allocations = [];

    allocationRows.forEach((row) => {
      const containerId = row.dataset.containerId;
      const dryingUnitId =
        row.querySelector("[data-field=drying_unit_id]")?.value || "";
      const allocatedWeight =
        parseFloat(
          row.querySelector("[data-field=allocated_weight_value]")?.value,
        ) || 0;

      allocations.push({
        container_id: parseInt(containerId),
        drying_unit_id: dryingUnitId,
        allocated_weight_value: allocatedWeight,
      });
    });

    this.containersDataFieldTarget.value = JSON.stringify(allocations);

    // Serialize group settings
    if (this.hasGroupCardTarget && this.hasDryingGroupsDataFieldTarget) {
      const groups = [];
      this.groupCardTargets.forEach((card) => {
        const dryingUnitId = card.dataset.dryingUnitId;
        const method = card.querySelector("[data-field=method]")?.value || "";
        const recipe = card.querySelector("[data-field=recipe]")?.value || "";
        const temperatureSetpoint = this.parseOptionalFloat(
          card.querySelector("[data-field=temperature_setpoint]")?.value,
        );
        const humiditySetpoint = this.parseOptionalFloat(
          card.querySelector("[data-field=humidity_setpoint]")?.value,
        );
        const moistureFinalPercentage = this.parseOptionalFloat(
          card.querySelector("[data-field=moisture_final_percentage]")?.value,
        );

        groups.push({
          drying_unit_id: parseInt(dryingUnitId),
          method,
          recipe,
          temperature_setpoint: temperatureSetpoint,
          humidity_setpoint: humiditySetpoint,
          moisture_final_percentage: moistureFinalPercentage,
        });
      });

      this.dryingGroupsDataFieldTarget.value = JSON.stringify(groups);
    }
  }

  parseOptionalFloat(value) {
    const parsedValue = parseFloat(value);

    if (Number.isNaN(parsedValue)) {
      return null;
    }

    return parsedValue;
  }
}
